import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Mail, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FinalCTA = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/early-access`, { email, source: "final_cta" });
      setSubmitted(true);
      setEmail("");
      toast.success("You're on the list. We'll be in touch.");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A] overflow-hidden"
    >
      <div className="absolute left-1/2 -translate-x-1/2 top-0 w-[800px] h-[400px] bg-[#C6FF00]/10 blur-[140px] rounded-full pointer-events-none" />

      <div className="relative container mx-auto max-w-5xl px-6 md:px-10 text-center">
        <p className="text-xs uppercase tracking-[0.35em] text-[#C6FF00] font-semibold mb-6">
          Last Set
        </p>
        <h2 className="font-heading text-5xl md:text-7xl lg:text-[7.5rem] text-white leading-[0.9]">
          IF YOU CAN SHOW
          <br />
          UP AT 6AM…
          <br />
          <span className="text-[#C6FF00]">YOU CAN SHOW UP HERE.</span>
        </h2>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/register"
            data-testid="final-cta-find-match-btn"
            className="group inline-flex items-center justify-center gap-2 bg-[#C6FF00] hover:bg-[#AEE600] text-[#0A0A0A] font-bold text-base uppercase tracking-[0.2em] px-10 py-5 rounded-md transition-all duration-300 hover:scale-105 shadow-[0_0_30px_rgba(198,255,0,0.4)] hover:shadow-[0_0_60px_rgba(198,255,0,0.6)]"
          >
            Find Your Match
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <a
            href="mailto:trainers@swolemates.app"
            data-testid="final-cta-trainer-btn"
            className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white/30 hover:border-[#C6FF00] hover:text-[#C6FF00] text-white font-bold text-base uppercase tracking-[0.2em] px-10 py-5 rounded-md transition-all duration-300"
          >
            Have a Trainer?
          </a>
        </div>

        {/* Email capture */}
        <div className="mt-20 max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-[0.3em] text-neutral-400 font-semibold mb-4">
            Get Early Access
          </p>
          <form
            onSubmit={handleSubmit}
            data-testid="early-access-form"
            className="relative bg-[#111111] border border-white/10 rounded-full p-2 flex items-center gap-2 focus-within:border-[#C6FF00] transition-colors"
          >
            <Mail
              size={18}
              className="text-neutral-500 ml-4 flex-shrink-0 hidden sm:block"
            />
            <input
              id="early-access-input"
              data-testid="early-access-email-input"
              type="email"
              placeholder="you@gymrat.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={submitted}
              className="flex-1 bg-transparent border-0 outline-none text-white placeholder:text-neutral-500 text-sm md:text-base px-4 py-3 font-body min-w-0"
            />
            <button
              type="submit"
              disabled={loading || submitted}
              data-testid="early-access-submit-btn"
              className="flex-shrink-0 inline-flex items-center gap-2 bg-[#C6FF00] hover:bg-[#AEE600] text-[#0A0A0A] font-bold text-xs sm:text-sm uppercase tracking-[0.2em] px-5 sm:px-7 py-3 rounded-full transition-all duration-300 disabled:opacity-60"
            >
              {submitted ? (
                <>
                  <CheckCircle2 size={16} /> On The List
                </>
              ) : loading ? (
                "Joining…"
              ) : (
                <>
                  Join <ArrowRight size={14} />
                </>
              )}
            </button>
          </form>
          <p className="text-[11px] text-neutral-500 mt-4">
            No spam. Just early invites and launch perks.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
